<ng-container *ngIf="loading">
  <div class="loader">
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
  </div>
  <div style="z-index: 4" class="loader-text">Adding product...</div>
</ng-container>
<div class="flex justify-content-end flex-wrap mt-1 mr-1">
  <button mat-icon-button color="primary" mat-dialog-close>
    <mat-icon matSuffix>close</mat-icon>
  </button>
</div>
<div class="header-container">
  <h1 style="margin: 0px !important">Add a Product</h1>
</div>
<mat-dialog-content>
  <p class="pt-1">Ensure your product information is accurate before saving.</p>
  <mat-stepper linear #stepper class="stepper">
    <mat-step [stepControl]="productDetailFormGroup" state="number">
      <ng-template matStepLabel>Product Details</ng-template>
      <product-detail-form
        [productDetailFormGroup]="productDetailFormGroup"
        [selectedTagList]="selectedTagList"
        [store]="data.store"
      >
      </product-detail-form>
    </mat-step>
    <mat-step [stepControl]="pricingFormGroup">
      <ng-template matStepLabel>Pricing</ng-template>
      <product-pricing-form [pricingFormGroup]="pricingFormGroup">
      </product-pricing-form>
    </mat-step>
    <mat-step [stepControl]="uomFormGroup">
      <ng-template matStepLabel>UOM</ng-template>
      <product-uom-form [uomFormGroup]="uomFormGroup"> </product-uom-form>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>Availability</ng-template>
      <product-availability
        #availabilityRef
        [availabilityControl]="availabilityControl"
        [storeSelectedSet]="storeSelectedSet"
        (createProduct)="onHandleCreateProduct()"
      >
      </product-availability>
    </mat-step>

    <!-- Override -->
    <ng-template matStepperIcon="edit">
      <mat-icon>check</mat-icon>
    </ng-template>
  </mat-stepper>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    mat-stroked-button
    class="mr-2 mb-2"
    (click)="stepper.previous()"
    [disabled]="loading || stepper.selectedIndex === 0"
  >
    Back
  </button>
  <button
    mat-flat-button
    color="primary"
    (click)="stepper.selectedIndex === 3 ? availabilityRef.onCreateProduct() : stepper.next()"
    [disabled]="
      loading ||
      (stepper.selectedIndex === 0 && productDetailFormGroup.invalid) ||
      (stepper.selectedIndex === 1 && pricingFormGroup.invalid) ||
      (stepper.selectedIndex === 2 && uomFormGroup.invalid) ||
      (stepper.selectedIndex === 3 && (productDetailFormGroup.invalid || pricingFormGroup.invalid || uomFormGroup.invalid))
    "
    cdkFocusInitial
  >
    {{ stepper.selectedIndex === 3 ? 'Add Product' : 'Next' }}
  </button>
</mat-dialog-actions>